export const TRANSLATION_EN_US = {
  titleHome: 'Sales',
  captionHome: 'New sale',

  progress: {
    first: 'Home',
    second: 'Client',
    third: 'Attach file',
    fourth: 'Payments',
    fifth: 'Contract',
  },

  total: {
    title: 'Subtotal',
  },

  findClient: {
    title: 'Find client',
    findClient: 'Find client',
    select: 'Select',
    noOption: 'No option',
    buttonFetch: 'Find',
    buttonAdd: 'Add Person',
    buttonAtt: 'Update',
    name: 'Full name',
    issuingBody: 'Issuing body',
    telephone: 'Telephone',
    cellPhone: 'Cell phone',
    dateOfBirth: 'Date of birth',
    nationality: 'Nationality',
    stateOfBirth: 'State of birth',
    cityOfBirth: 'Place of birth (City)',
    maritalStatus: 'Marital status',
    gender: 'Gender',
  },

  attachFile: {
    title: 'Attach files',
    info: 'Drag inside or <strong>click</strong> to select a file',
    description: 'Supported formats: PDF, Word, JPG, XLS, and PNG',
  },

  buttonContinue: 'Continue',
  buttonBack: 'Back',
  buttonDelete: 'Delete',

  modal: {
    title: 'Are you sure you want to delete this file?',
    description: 'Changes will be saved and action cannot be undone.',
  },

  modalAcknowledgment: {
    title: 'Opss!!',
    description:
      'The rest of the flow is still under development but will be available soon.',
  },

  calendar: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },

  cleanForm: 'Clean form',
}
